import React, { useEffect, useState } from 'react'
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
    FormText,
    Collapse,
    Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, CardHeader,

} from "reactstrap";
import { apiService } from './ApiService';
import { toast } from 'react-toastify';

const RemarkPage = (props) => {

    const initialRemarkDetail = {
        upload_document_name: "",
        upload_document_path: null,
        remarks: "",
        attended_by: "",

        document_type_name: "",
        document_typeId: null
    }
    let backendURL = process.env.REACT_APP_API_BASE_URL;
    const [remarkData, setRemarkData] = useState(initialRemarkDetail)
    const [remarkArray, setRemarkArray] = useState([])
    const [removeRemarkArray, setRemoveRemarkArray] = useState([])
    const [openAccordion, setOpenAccordion] = useState(null);

    const toggleAccordion = (index) => {
        setOpenAccordion((prevIndex) => (prevIndex === index ? null : index));
    };

    const handleInputChange = (e) => {
        const { name, value, files, type } = e.target;

        if (type === "file") {
            setRemarkData((prevState) => ({
                ...prevState,
                [name]: files[0],
            }));
        } else {

            if (name === "document_typeId") {

                let findArray = props.helperMasterDocumentTypeTable.find((data) => data.id === value);
                setRemarkData((prevState) => ({
                    ...prevState,
                    [name]: value,
                    document_type_name: findArray.field_data
                }));

            } else {
                setRemarkData((prevState) => ({
                    ...prevState,
                    [name]: value,
                }));
            }


        }
    };

    const AddRemarkData = () => {
        setRemarkArray((prevState) => [...prevState, remarkData]);
        setRemarkData(initialRemarkDetail);

        props?.setremarkPageArrayList((prevState) => [...prevState, remarkData])
    }

    const RemoveRemarkData = (index) => {
        setRemarkArray((prevState) => {
            // Get the item to remove using the index
            const itemToRemove = prevState[index];

            // Create a new array without the item at the specified index
            const updatedArray = prevState.filter((_, i) => i !== index);

            // If the item exists, add it to the removeRemarkArray
            if (itemToRemove) {
                setRemoveRemarkArray((prevDeleteState) => [...prevDeleteState, itemToRemove]);
            }
            return updatedArray;
        });


        props?.setremarkPageArrayList((prevState) => {
            // Get the item to remove using the index
            const itemToRemove = prevState[index];

            // Create a new array without the item at the specified index
            const updatedArray = prevState.filter((_, i) => i !== index);

            // If the item exists, add it to the removeRemarkArray
            if (itemToRemove) {
                props.setDeleteRemarkPageArrayList((prevDeleteState) => [...prevDeleteState, itemToRemove]);
            }
            return updatedArray;
        });
    };


    return (
        <>

            <div>
                <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                    style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }} onClick={() => toggleAccordion(1)}>
                    <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "blue" }}>
                        <i className="bi bi-bell me-2"></i>
                        Remark Detail And Upload Documents
                    </div>

                    {openAccordion === 1 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}

                </CardTitle>
                <Collapse isOpen={openAccordion === 1}>
                    <CardBody>
                        <Form>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Document Image</Label>
                                        <Input className="custom-border"
                                            type="file"
                                            id="upload_document_path"
                                            name="upload_document_path"
                                            onChange={handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col>
                                    <FormGroup>
                                        <Label>Document Type 
                                        <i
                                      className="fa fa-plus-circle"
                                      onClick={() => { props.openHelperModal( props.fromName) }}
                                      style={{ cursor: 'pointer', marginLeft: '10px', color: "blue", fontSize: 20 }}
                                    ></i>
                                        </Label>
                                        <Input className="custom-border"
                                            type="select"
                                            id="document_typeId"
                                            name="document_typeId"
                                            onChange={handleInputChange}
                                        >
                                            <option value="">select</option>
                                            {props?.helperMasterDocumentTypeTable.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.field_data}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>Remarks</Label>
                                        <Input className="custom-border"
                                            type="text"
                                            id="remarks"
                                            name="remarks"
                                            value={remarkData.remarks}
                                            onChange={handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>Attended by</Label>
                                        <Input className="custom-border"
                                            type="text"
                                            id="attended_by"
                                            name="attended_by"
                                            value={remarkData.attended_by}
                                            onChange={handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>

                        <Button type="Save" onClick={() => { AddRemarkData() }}>Add </Button>


                        {props.remarkPageArrayList.length !== 0 && <div style={{ border: "2px solid #c4bbbb", padding: 10, borderRadius: 10, marginBottom: 20, marginTop: 20 }}>
                            <h6>Remarks Detail and Upload Document</h6>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: "1px solid #c4bbbb", padding: 10 }}>Document Path</th>
                                        <th style={{ border: "1px solid #c4bbbb", padding: 10 }}>Document Type</th>
                                        <th style={{ border: "1px solid #c4bbbb", padding: 10 }}>Remarks</th>
                                        <th style={{ border: "1px solid #c4bbbb", padding: 10 }}>Attended By</th>
                                        <th style={{ border: "1px solid #c4bbbb", padding: 10 }}>Delete</th>

                                    </tr>
                                </thead>
                                <tbody>

                                    {props.remarkPageArrayList.map((item, index) => {
                                        // const baseUrl = "http://localhost:5200/";
                                        const imageUrl = item.upload_document_path ? `${backendURL}${item.upload_document_path}` : null;


                                        return (
                                            <tr key={index}>
                                                <td style={{ border: "1px solid #c4bbbb", padding: 10 }}>
                                                    {imageUrl ? (
                                                        <img src={imageUrl} alt="Uploaded Document" style={{ height: '100px' }} />
                                                    ) : (
                                                        'No file uploaded'
                                                    )}
                                                </td>
                                                <td style={{ border: "1px solid #c4bbbb", padding: 10 }}>{item.document_type_name}</td>
                                                <td style={{ border: "1px solid #c4bbbb", padding: 10 }}>{item.remarks}</td>
                                                <td style={{ border: "1px solid #c4bbbb", padding: 10 }}>{item.attended_by}</td>
                                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        onClick={() => RemoveRemarkData(index)}
                                                    >
                                                        Delete
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>}
                    </CardBody>
                </Collapse>
            </div>
        </>
    )
}

export default RemarkPage